export const AbsoluteZeroInDegreesCelsius = -273.15;
